<template>
  <div style="width: 100vw; height: 100vh; z-index: 900; margin: 0 !important">
    <div style="margin-top: calc(50vh - 25px); margin-left: calc(50vw - 100px)">
      <span>
        <i18n path="views.error.504.serverUnreachable" tag="span">
          <template #retry>
            <span
              class="cursor-pointer"
              @click="retry"
              style="color: var(--primary)"
              >{{ $t("views.error.504.retry") }}</span
            >
          </template>
        </i18n>
      </span>
      <!-- <v-btn @click="$router.push('/')" color="primary-btn">Retry</v-btn>) -->
    </div>
    <!-- <v-card class="mx-auto" max-width="400">
      <v-img
        style="background:white"
        class="black--text align-end"
        height="320px"
        :src="serverOfflineImage"
      >
      </v-img>

      <v-card-subtitle class="pb-0">Server offline</v-card-subtitle>

      <v-card-text class="text--primary">
        <div>Could not reach the server</div>
      </v-card-text>

      <v-card-actions>
        <v-btn style="margin-left:295px" right small @click="$router.push('/')" color="primary-btn"
          >Try again</v-btn
        >
      </v-card-actions>
    </v-card> -->
  </div>
</template>

<script>
export default {
  name: "Error504",

  methods: {
    retry() {
      localStorage.setItem("jwt", null);
      this.$store.commit("setJWT", null);
      this.$router.push({ name: "Login" }).catch(() => {
        // to avoid NavigationDuplicated Navigating to current location /login is not allowed
      });
      this.$store.state.showLoading = true;
      setTimeout(() => {
        this.$store.state.showLoading = false;
      }, 1000);
    },
  },
};
</script>